<section>
  <cert-dns-firewall-table
    [dnsFirewallLogs]="dnsFirewallLogs()"
    [pageInfo]="pageInfo()"
    (paginationChanged)="onPaginationChanged($event)"
    (sortingChanged)="onSortingChanged($event)"
  ></cert-dns-firewall-table>
</section>
